var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        _vm.$style.checkBoxRadioInput,
        _vm.disabled && _vm.$style.disabled,
        _vm.$style[_vm.align],
        _vm.$style[_vm.type],
      ],
    },
    [
      _c(
        "label",
        { class: _vm.$style.checkBoxContainer, attrs: { for: _vm.id } },
        [
          _vm.align === "right"
            ? _vm._t("default", function () {
                return [
                  _c(
                    "span",
                    {
                      class: [
                        _vm.$style.label,
                        _vm.correct && _vm.$style.correct,
                        _vm.error && _vm.$style.error,
                        _vm.passed && _vm.$style.passed,
                      ],
                    },
                    [_vm._v(" " + _vm._s(_vm.label) + " ")]
                  ),
                ]
              })
            : _vm._e(),
          _vm.type === "checkbox"
            ? _c("input", {
                class: _vm.$style.input,
                attrs: { id: _vm.id, type: "checkbox", disabled: _vm.disabled },
                domProps: { checked: _vm.value },
                on: {
                  change: function ($event) {
                    return _vm.$emit("update:value", $event.target.checked)
                  },
                },
              })
            : _c("input", {
                class: _vm.$style.input,
                attrs: {
                  id: _vm.id,
                  type: "radio",
                  name: _vm.radioGroupName,
                  disabled: _vm.disabled,
                },
                domProps: {
                  checked: _vm.value === _vm.radioValue,
                  value: _vm.radioValue,
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("update:value", $event.target.value)
                  },
                },
              }),
          _c("div", {
            class: [
              _vm.$style.checkBoxIndicator,
              _vm.correct && _vm.$style.correct,
              _vm.error && _vm.$style.error,
              _vm.passed && _vm.$style.passed,
            ],
          }),
          _vm.align === "left"
            ? _vm._t("default", function () {
                return [
                  _c(
                    "span",
                    {
                      class: [
                        _vm.$style.label,
                        _vm.correct && _vm.$style.correct,
                        _vm.error && _vm.$style.error,
                        _vm.passed && _vm.$style.passed,
                      ],
                    },
                    [_vm._v(" " + _vm._s(_vm.label) + " ")]
                  ),
                ]
              })
            : _vm._e(),
          _c(
            "transition",
            { attrs: { name: "slide-fade" } },
            [
              _vm.error
                ? _c("Error", [_vm._v(" " + _vm._s(_vm.error) + " ")])
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _vm.customInput
        ? _c("input", {
            class: _vm.$style.customInput,
            attrs: { type: "text" },
            on: {
              input: function ($event) {
                return _vm.$emit("update:customValue", $event.target.value)
              },
            },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }